import { Navigate, Outlet, useLocation, useParams } from 'react-router'

import { ConnectionSetupRoutes } from 'app/application/types'
import { Account, InstalledConnection, SupportedAccount } from 'app/connections/types'

import { mapToConnectionName } from '../../connectionUrlMapper'

type StepParams = {
  name: string
}

interface StepState {
  accounts: SupportedAccount[]
  connection: InstalledConnection
}

export interface StepContext<A extends SupportedAccount = SupportedAccount> {
  accounts: Account<A>[]
  connection: InstalledConnection
}

const StepWithConnectionAndAccounts = () => {
  const location = useLocation()
  const { name } = useParams<StepParams>() as StepParams

  const state = location.state as StepState | null
  const { accounts, connection } = state ?? { accounts: [] }

  if (!connection || connection.name !== mapToConnectionName(name)) {
    return <Navigate to={`/connections/${name}/setup`} replace />
  }

  if (!accounts.length) {
    return (
      <Navigate
        to={`/connections/${name}/setup/${ConnectionSetupRoutes.SelectAccounts}/`}
        replace
        state={{ connection }}
      />
    )
  }

  return <Outlet context={{ accounts, connection }} />
}

export default StepWithConnectionAndAccounts
